<script>
import CartApiService from './../../../class/service/CartApiService';

export default {
    data() {
        let cart = {
            places: [],
        };

        let cartApiService = new CartApiService();

        return {
            cart: cart,
            couponList: [],
            loading: false,
            cartApiService: cartApiService,
        };
    },

    mounted() {
        this.loadCart();
    },

    methods: {
        loadCart() {
            this.loading = true;

            this.cartApiService
                .getCart('current')
                .then((cart) => {
                    this.cart = cart;
                    this.couponList = cart.couponList;
                })
                .catch((error) => {
                    this.$refs.alertBox.handleError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
